import * as yup from 'yup';

const locationItem = yup.object().shape({
  isShowState: yup.boolean(),
  country: yup.string().nullable(),
  address1: yup.string().nullable(),
  address2: yup.string().nullable(),
  state: yup.string().nullable()
    .when('isShowState', {
      is: true,
      then: yup.string().required('Required').nullable(),
      otherwise: yup.string().nullable()
    }),
  province: yup.string().nullable(),
  zip: yup.string().nullable(),
  city: yup.string().nullable().required('Required'),
});

export const schema:any = yup.object().shape({
  salaryUnitId: yup.number().nullable(),

  showSalaryExact: yup.boolean(),

  salaryMin: yup.number().nullable().when('salaryUnitRadio', {
    is: 2,
    then: yup.number().required('Required').nullable(),
    otherwise: yup.number().nullable()
  }),
  salaryMax: yup.number().nullable().when('salaryUnitRadio', {
    is: 2,
    then: yup.number().required('Required').nullable(),
    otherwise: yup.number().nullable()
  }),
  salaryExact: yup.number().nullable()
    .when('showSalaryExact', {
      is: true,
      then: yup.number().required('The Salary Exact field is required.').nullable(),
      otherwise: yup.number().nullable()
    }),
  noneLocation: yup.boolean(),
  salaryUnitRadio: yup.number(),

  // A non-remote listing must have at least one location. This array-level message is
  // rendered inline by Step2 (the rows only render errors.locations[index]), so the
  // location error shows under the field like the Post a Job flow instead of a toast.
  locations: yup.array().of(locationItem).when('noneLocation', {
    is: false,
    then: yup.array().of(locationItem).min(1, 'Please add at least one job location, or mark this job as remote.'),
    otherwise: yup.array().of(locationItem)
  })
});
